<!--
 * @Author: wh
 * @Date: 2020-07-16 14:37:16
 * @LastEditTime: 2020-07-21 22:01:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\orderSituation\logisticsVehicleInfo.vue
-->
<template>
    <div class="logisticsVehicleInfo">
        <van-nav-bar
            title="物流车辆信息"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="wapper">
            <!-- 地图对象 -->
            <BaiduMap
                class="map"
                ref="map"
                :center="center"
                :zoom="zoom"
                ak="8oGi1YBeLNnGA54yA1YuyumkzjjfGqmW"
            >
                <!-- 线路 -->
                <bm-polyline
                    :path="polyline.path"
                    :stroke-color="polyline.strokeColor"
                    :stroke-style="polyline.strokeStyle"
                ></bm-polyline>
                <!-- 场站/工地 -->
                <bm-marker
                    v-for="(station, index) in stations"
                    :position="station.position"
                    :key="`station${index}`"
                    :icon="station.icon"
                ></bm-marker>
                <!-- 车辆 -->
                <bm-marker
                    v-for="(car, index) in cars"
                    :position="car.position"
                    :key="`car${index}`"
                    :icon="car.icon"
                    :rotation="car.rotation"
                    :offset="{width: -20, height: -12}"
                    @click="switchWindow(index, car, car.position)"
                ></bm-marker>
            </BaiduMap>
            <!-- 车辆筛选 -->
            <div class="carstatus-btns">
                <ul>
                    <li
                        :class="{'active':carstatusActive===item.status}"
                        v-for="(item,index) in carstatus"
                        :key="`carstatus${index}`"
                        @click="changeCarStatus(item.status)"
                    >
                        {{ item.name }}
                    </li>
                </ul>
            </div>
            <!-- 车辆信息 -->
            <div class="carinfo" v-if="showCarInfo">
                <div class="top">
                    <h4>{{ carInfo.plate_number }}<span class="small-num">{{ carInfo.plate_small_number }}</span></h4>
                    <div class="describe">
                        <span>{{ carInfo.strength_grade_name }}</span>
                        <span>车次（{{ carInfo.grand_total_vehicle }}）</span>
                    </div>
                </div>
                <div class="main">
                    <ul>
                        <li class="tit">
                            <span class="iconfont icondanjubianhao"></span>
                            <span class="info">运输单编号：{{ carInfo.pcb_number }}</span>
                        </li>
                        <li>
                            <span class="pre-icon material35"></span>
                            <span class="info">司机：{{ carInfo.driver_name }}</span>
                        </li>
                        <li>
                            <span class="pre-icon material31"></span>
                            <span class="info">供应场站：{{ carInfo.mixstation_name }}</span>
                        </li>
                        <li>
                            <span class="pre-icon material25"></span>
                            <span class="info">本车方量：{{ carInfo.volume }}m³</span>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="12">
                                    <span class="pre-icon material24"></span>
                                    <span class="info">计划方量：{{ carInfo.quantity }}m³</span>
                                </van-col>
                                <van-col span="12">
                                    <span class="pre-icon material25"></span>
                                    <span class="info">累计方量：{{ carInfo.grand_total_quantity }}m³</span>
                                </van-col>
                            </van-row>
                        </li>
                    </ul>
                </div>
                <div class="bottom">
                    <h4 class="time">
                        出厂时间：{{ carInfo.out_time }}
                    </h4>
                    <span class="know-btn" @click="showCarInfo=false">知道了</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/common/eventBus.ts';
import BaiduMap from 'vue-baidu-map-v3/components/map/Map.vue';
import BmPolyline from 'vue-baidu-map-v3/components/overlays/Polyline.vue';
import BmMarker from 'vue-baidu-map-v3/components/overlays/Marker.vue';
export default {
    name: 'logistics-vehicle-info',
    components: { BaiduMap, BmPolyline, BmMarker },
    props: {},
    data() {
        return {
            zoom: 9,
            center: { lng: 0, lat: 0 },
            // 是否显示车辆信息
            showCarInfo: false,
            // 路径
            polyline: {
                path: [],
                strokeColor: '#3495FB',
                strokeStyle: 'solid',
            },
            // 场站/工地
            stations: [
                {
                    icon: { size: { width: 30, height: 30 }, url: require('./../../../../assets/images/orderSitiation/station.png') },
                    position: { lng: 0, lat: 0 },

                },
                {
                    icon: { size: { width: 30, height: 30 }, url: require('./../../../../assets/images/orderSitiation/site0.png') },
                    position: { lng: 0, lat: 0 },
                },
            ],
            // 车辆
            cars: [],
            // 订单编号
            order_number: '',
            // 任务单数据
            mapTaskData: {},
            // 运输单下车辆
            orderCars: [],
            // 车辆状态
            carstatus: [
                { name: '全部车辆', status: 0 },
                { name: '运输中', status: 1 },
                { name: '已到达', status: 2 },
                { name: '卸料中', status: 3 },
            ],
            carstatusActive: 0,
            carPosition: {},
            // 车辆信息
            carInfo: {},
        };
    },
    watch: {
        carPosition: {
            deep: true,
            immediate: true,
            handler: function (val) {
                this.cars.forEach(item => {
                    if (item.plate_number === val.car_license) {
                        item.position = { lng: val.longitude, lat: val.latitude };
                        let direction;
                        if (val.direction) {
                            direction = parseInt(val.direction, 0);
                        } else {
                            direction = 0;
                        }
                        item.rotation = direction;
                    }
                });
                this.$forceUpdate();
            },
        },
    },
    computed: {},
    created() {},
    mounted() {
        this.order_number = this.$route.params.order_number;
        this.getMapTask();
        this.getOrderCars();
        eventBus.$on('MapCarChangeMsg', data => {
            this.mapCarChange(data);
        });
        eventBus.$on('CoordinateMessage', data => {
            this.carPosition = JSON.parse(data);
        });
    },
    beforeDestroy() {
        eventBus.$off('MapCarChangeMsg');
        eventBus.$off('CoordinateMessage');
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 任务地图信息
        async getMapTask() {
            const res = await this.getMapTaskApi();
            if (res) {
                this.mapTaskData = res;
                if (this.mapTaskData.station_longitude && this.mapTaskData.stationt_latitude) {
                    this.stations[0].position = { lng: this.mapTaskData.station_longitude, lat: this.mapTaskData.stationt_latitude };
                    this.center = { lng: this.mapTaskData.station_longitude, lat: this.mapTaskData.stationt_latitude };
                }
                if (this.mapTaskData.project_longitude && this.mapTaskData.project_latitude) {
                    this.stations[1].position = { lng: this.mapTaskData.project_longitude, lat: this.mapTaskData.project_latitude };
                }
                if (this.mapTaskData.gd_lines) {
                    const orignal = this.mapTaskData.gd_lines;
                    const arr1 = orignal.split(';');
                    const result = [];
                    for (let j = 0; j < arr1.length; j++) {
                        const element = arr1[j];
                        const item = element.split(',');
                        for (let i = 0; i < item.length; i += 2) {
                            const pos = item.slice(i, i + 2);
                            result.push({
                                lng: pos[0],
                                lat: pos[1],
                            });
                        }
                    }
                    this.$nextTick(() => {
                        this.polyline.path = result;
                    });
                }
            }
        },
        // 订单运输中车辆
        async getOrderCars() {
            const res = await this.getOrderCarsApi();
            if (res) {
                const teampArr = res.filter(item => [1, 2, 3].indexOf(item.status) !== -1);
                this.orderCars = teampArr;
                const carMarkers = this.parseMarker(teampArr);
                this.$nextTick(() => {
                    this.cars = carMarkers;
                });
            }
        },
        // 筛选车辆
        changeCarStatus(status) {
            this.carstatusActive = status;
            let arrObj = [];
            if (status === 0) {
                arrObj = this.orderCars;
            } else {
                arrObj = this.orderCars.filter(item => item.status === status);
            }
            const carMarkers = this.parseMarker(arrObj);
            this.$nextTick(() => {
                this.cars = carMarkers;
            });
        },
        // 车辆状态变更
        mapCarChange(data) {
            if (data.order_number === this.order_number) {
                if ([1, 2, 3].indexOf(data.status) !== -1) {
                    const arr = this.cars.filter(item => item.plate_number === data.plate_number);
                    if (arr.length < 1) {
                        const carMarker = {
                            position: { lng: data.longitude, lat: data.latitude },
                            rotation: data.direction,
                            icon: {
                                url: require('./../../../../assets/images/orderSitiation/trans_car.png'),
                                size: { width: 22, height: 38 },
                            },
                            plate_number: data.plate_number,
                            status: data.status,
                        };
                        if (data.status === 1) {
                            carMarker.icon.url = require('./../../../../assets/images/orderSitiation/trans_car.png');
                        } else if (data.status === 2) {
                            carMarker.icon.url = require('./../../../../assets/images/orderSitiation/arrived_car.png');
                        } else if (data.status === 3) {
                            carMarker.icon.url = require('./../../../../assets/images/orderSitiation/unload_car.png');
                        }
                        this.cars.push(carMarker);
                    } else {
                        this.cars = this.cars.map(item => {
                            if (item.plate_number === data.plate_number) {
                                item.status = data.status;
                                if (item.status === 1) {
                                    item.icon.url = require('./../../../../assets/images/orderSitiation/trans_car.png');
                                } else if (item.status === 2) {
                                    item.icon.url = require('./../../../../assets/images/orderSitiation/arrived_car.png');
                                } else if (item.status === 3) {
                                    item.icon.url = require('./../../../../assets/images/orderSitiation/unload_car.png');
                                }
                            }
                            return item;
                        });
                    }

                } else {
                    const deleteIndex = this.cars.findIndex(item => {
                        return item.plate_number === data.plate_number;
                    });
                    if (deleteIndex >= 0) {
                        this.cars.splice(deleteIndex, 1);
                    }
                }
            }
        },
        // 展示车辆信息
        async switchWindow(index, data, position) {
            const res = await this.getVehicleOrder(data);
            if (res) {
                this.showCarInfo = true;
                this.carInfo = res;
            }
        },
        // 根据车辆数据生成marker
        parseMarker(orginal) {
            const carMarkers = [];
            orginal.map((item, index) => {
                const carMarker = {
                    position: { lng: item.longitude, lat: item.latitude },
                    rotation: item.direction,
                    icon: {
                        url: require('./../../../../assets/images/orderSitiation/trans_car.png'),
                        size: { width: 22, height: 38 },
                    },
                    plate_number: item.plate_number,
                    status: item.status,
                };
                if (item.status === 1) {
                    carMarker.icon.url = require('./../../../../assets/images/orderSitiation/trans_car.png');
                } else if (item.status === 2) {
                    carMarker.icon.url = require('./../../../../assets/images/orderSitiation/arrived_car.png');
                } else if (item.status === 3) {
                    carMarker.icon.url = require('./../../../../assets/images/orderSitiation/unload_car.png');
                }
                carMarkers.push(carMarker);
            });
            return carMarkers;
        },
        getMapTaskApi() {
            return this.$axios.$get('/interfaceApi/production/producttask/get_map_task?order_number=' + this.order_number, { defEx: true });
        },
        getOrderCarsApi() {
            return this.$axios.$get('/interfaceApi/production/producttask/get_order_cars?order_number=' + this.order_number, { defEx: true });
        },
        // 获取车辆信息
        getVehicleOrder(data) {
            return this.$axios.$get('/interfaceApi/production/vehicleinfo/get_vehicle_order?plate_number=' + data.plate_number, { defEx: true });
        },
    },

};
</script>
<style lang="stylus">
@import './index.stylus'
</style>
